<template>
  <div class="modal fade" id="modalLogin" tabindex="-1" data-container="#modalLogin" style="display: none;"
    aria-hidden="true">
    <div class="modal-dialog modal-dialog-scrollable modal-dialog-centered" role="document" style="margin-top: 28px;">
      <div class="modal-content -modal-content">
        <button type="button" class="close f-1 " data-dismiss="modal" aria-label="Close">
          <img src="/static/img/landing/prediction-close.png" alt="Close" style="width: 20px; height: 20px;">
        </button>

        <div class="modal-body">
          <div class="text-center py-2 logologinmodal">
            <a href="/" class="custom-logo-link" rel="home" aria-current="page"><img
                src="/static/img/landing/cropped-GMZ555.png" class="custom-logo"
                alt="VENOM168 สล็อตออนไลน์ เว็บตรง100%"></a>
          </div>
          <div class="form-login">
            <div class="">
              <div class="input-group mb-3">

                <input v-model="phoneNumber" class=" mb-4 mt-3 form-control x-form-control text-center" id="txtUserName"
                  type="text" placeholder="ชื่อผู้ใช้">


              </div>

              <div class="input-group mb-3">
                <input v-model="password" class="form-control x-form-control text-center" id="password" name="password"
                  type="password" placeholder="รหัสผ่าน">
              </div>

              <div class="input-group mb-3">
                <input v-model="remember" :value="true" type="checkbox" id="f-condition" class="form-check-input" />
                <label for="f-condition" class="form-check-label">
                  จดจำฉันไว้ในระบบ
                </label>
                <div class="d-block w-100 p-1"></div>
              </div>


              <div class="pb-1 login-desktop text-center">
                <button type="button" class="btn btn-lg btn-login" @click="Login()" id="btnLoginForn">เข้าสู่ระบบ</button>
              </div>
              <div class="pb-1 login-mobile text-center">
                <button type="button" class="btn btn-lg btn-login" @click="Login()"
                  id="btnLoginForn2">เข้าสู่ระบบ</button>
              </div>
            </div>
            <div class="footer-form py-3">
              <div class="row ">
                <div class="col-8">
                  <span class="text-white">ท่านยังไม่มีบัญชี?</span> <a href="javascript:;" style="" data-toggle="modal"
                    data-dismiss="modal" data-target="#modalRegister"><u>สมัครสมาชิก</u></a>
                </div>
                <div class="col-4 text-right">
                  <a v-bind:href="`https://line.me/R/ti/p/${getLineId}`" target="_blank"
                    class="text-decoration-none text-white">ลืมรหัสผ่าน
                    ?</a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'

export default {
  name: 'LoginForm',
  data() {
    return {
      phoneNumber: '',
      password: '',
      showpass: false,
      remember: false,
    }
  },
  computed: {
    ...mapGetters([
      'getError',
      'getLoading',
      'getLineId',
      'getGameList',
      'getPromotion',
    ]),
  },
  methods: {
    ...mapActions(['userSignIn', 'setError']),
    async Login() {
      if (
        this.phoneNumber == '' ||
        this.password == '' ||
        this.phoneNumber.length !== 10
      ) {
        return this.$swal.fire(
          'เบอร์โทรศัพท์ หรือ รหัสผ่าน ไม่ถูกต้อง',
          '',
          'error'
        )
      }
      await this.userSignIn({
        phoneNumber: this.phoneNumber,
        password: this.password,
      })
      if (this.getError) {
        return this.$swal.fire(this.getError, '', 'error')
      } else {
        // $('#modalLogin').modal('hide')
        if (this.remember == true) {
          localStorage.setItem('remember.username', this.phoneNumber)
          localStorage.setItem('remember.password', this.password)
        } else {
          localStorage.removeItem('remember.username')
          localStorage.removeItem('remember.password')
        }
        localStorage.removeItem('modal-alert')
      }
    },
  },
  mounted() {
    this.setError(null)
    if (localStorage.getItem('remember.username') != null) {
      this.phoneNumber = localStorage.getItem('remember.username')
      this.remember = true
    }
    if (localStorage.getItem('remember.password') != null) {
      this.password = localStorage.getItem('remember.password')
      this.remember = true
    }
  },
}
</script>

<style scoped>
.form-check-input[type=checkbox] {
  width: 1em;
  border-radius: 0.25em;

}

.form-check-label {
  color: #ffffff;
}
</style>



// WEBPACK FOOTER //
// src/components/form/LoginForm.vue